import { View, Text, styled } from 'tamagui'

const BadgeContainer = styled(View, {
  borderRadius: '$borderRadiusFull',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: 18,
  height: 18,
  paddingHorizontal: 5,
  variants: {
    variant: {
      mention: { backgroundColor: '$error' },
      unread: { backgroundColor: '$accent' },
    },
  } as const,
  defaultVariants: {
    variant: 'unread',
  },
})

const BadgeText = styled(Text, {
  fontSize: 11,
  fontWeight: '700',
  fontFamily: '$fontBody',
  variants: {
    variant: {
      mention: { color: '$surfaceForeground' },
      unread: { color: '$surface' },
    },
  } as const,
  defaultVariants: {
    variant: 'unread',
  },
})

interface BadgeProps {
  count: number
  variant?: 'mention' | 'unread'
}

export function Badge({ count, variant = 'unread' }: BadgeProps) {
  if (count <= 0) return null

  return (
    <BadgeContainer variant={variant}>
      <BadgeText variant={variant}>
        {count > 99 ? '99+' : count}
      </BadgeText>
    </BadgeContainer>
  )
}
